module.exports = __webpack_public_path__ + "img/CZ25307835.92b63cf6.png";